import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { motion } from "framer-motion";
import AtomOneLogo from "../assets/atomonelogo.jpg";
import "../styles/login.css";
import { useNavigate } from "react-router-dom";
import ThemeToggle from "./ThemeToggle";

const Login = () => {
  const { login } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const ok = await login(email, password);
    if (!ok) throw new Error();

    setSuccess(true);
    setError(false);

    // redirect after login
    setTimeout(() => {
      navigate("/dashboard", { replace: true });
    }, 600);

  } catch {
    setError(true);
    setSuccess(false);
    setTimeout(() => setError(false), 700);
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="login-page">
      <ThemeToggle />
      <motion.form
        onSubmit={handleSubmit}
        className={`login-card ${success ? "success" : ""}`}
        initial={{ opacity: 0, y: 30 }}
        animate={error ? "shake" : "rest"}
        variants={variants}
        transition={{ duration: 0.35 }}
      >
        {/* Logo */}
        <img
          src={AtomOneLogo}
          alt="Logo"
          className="login-logo"
        />

        <p className="login-subtitle">Secure Admin Access</p>

        {/* Email */}
        <div className={`input-wrapper ${error ? "error" : ""}`}>
          <input
            className="login-input"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            autoComplete="username"
            required
          />
        </div>

        {/* Password */}
        <div className={`input-wrapper ${error ? "error" : ""}`}>
          <input
            className="login-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type={showPassword ? "text" : "password"}
            autoComplete="current-password"
            required
          />
          <span
            className="password-eye"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "🙈" : "👁️"}
          </span>
        </div>

        {/* Error text */}
        {error && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="login-error"
          >
            Invalid email or password
          </motion.p>
        )}

        {/* Button */}
        <motion.button
          whileHover={!loading ? { scale: 1.02 } : {}}
          whileTap={!loading ? { scale: 0.97 } : {}}
          disabled={loading}
          className="login-button"
          style={{ opacity: loading ? 0.75 : 1 }}
          type="submit"
        >
          {loading ? "Signing in..." : "Sign In"}
        </motion.button>

        <p className="login-footer">
          © {new Date().getFullYear()} All rights reserved
        </p>
      </motion.form>
    </div>
  );
};

const variants = {
  rest: { x: 0, opacity: 1, y: 0 },
  shake: {
    x: [-6, 6, -4, 4, -2, 2, 0],
  },
};

export default Login;
